import * as React from 'react';
import * as styles from 'components/common/OrderForm/styles.scss';
import * as utils from 'components/common/OrderForm/utils';
import { Fallback, OtpModal } from 'components/common';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { formatDateToDisplay } from 'utils/datetime';
import { IOrderForm } from '../../config';
import { IAccount } from 'interfaces/common';
import { OrderKind, OrderType } from 'constants/enum';

interface IConfirmOrderModalModalProps
  extends React.ClassAttributes<ConfirmOrderModalComponent>,
    WithNamespaces {
  readonly values: IOrderForm;
  readonly isSubmitDisabled?: boolean;
  readonly orderKind: OrderKind;
  readonly selectedAccount: IAccount | null;
  readonly isStopLimitOrder?: boolean;
  readonly isConditionalOrder?: boolean;
  readonly isDerivatives?: boolean;

  readonly onCloseModal?: () => void;
  readonly onSubmit?: () => void;
}

class ConfirmOrderModalComponent extends React.Component<
  IConfirmOrderModalModalProps
> {
  constructor(props: IConfirmOrderModalModalProps) {
    super(props);
  }
  render() {
    const {
      t,
      values,
      isSubmitDisabled,
      isStopLimitOrder,
      isConditionalOrder,
      selectedAccount,
      isDerivatives,
      orderKind,
      onCloseModal,
      onSubmit,
    } = this.props;
    return (
   
        <OtpModal
          show={values.isConfirmModalOpened}
          onHide={onCloseModal}
          onSubmit={onSubmit}
          isSubmitDisabled={isSubmitDisabled}
          className={styles.newOTPModal}
          dialogClassName={styles.OrderFormDialog}
          type={values.sellBuyType}
        >
          {!values.skipConfirmation && (
            <div className={styles.ConfirmTable}>
              <div className={styles.Title}>
                {t(utils.getTitleModal(values.sellBuyType, orderKind))}
              </div>
              <table>
                <colgroup>
                  <col span={1} style={{ width: '50%' }} />
                  <col span={1} style={{ width: '50%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <div className={styles.flexOTP}>
                        <div className={styles.label}>{t('Account2')}</div>
                        <div className={styles.boxValue}>
                          {selectedAccount?.account}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={styles.flexOTP}>
                        <div className={styles.label2}>{t('KL placed')}</div>
                        <div className={styles.boxValue}>
                          {formatNumber(values.orderQuantity, 2)}
                        </div>
                      </div>
                    </td>
                  </tr>
                  {isStopLimitOrder || isConditionalOrder ? (
                    <>
                      <tr>
                        {values.stopPrice && (
                          <td>
                            <div className={styles.flexOTP}>
                              <div className={styles.label}>
                                {t('Stop Price')}
                              </div>
                              <div className={styles.boxValue}>
                                {formatNumber(values.stopPrice, 2)}
                              </div>
                            </div>
                          </td>
                        )}
                        {values.orderPrice && (
                          <td>
                            <div className={styles.flexOTP}>
                              <div className={styles.label2}>
                                {t('Limit Price')}
                              </div>
                              <div className={styles.boxValue}>
                                {formatNumber(values.orderPrice, 2)}
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                      <tr>
                        <td>
                          <div className={styles.flexOTP}>
                            <div className={styles.label}>{t('From Date')}</div>
                            <div className={styles.boxValue}>
                              {formatDateToDisplay(values.startDate)}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={styles.flexOTP}>
                            <div className={styles.label2}>{t('To Date')}</div>
                            <div className={styles.boxValue}>
                              {formatDateToDisplay(values.endDate)}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {values.orderPrice && (
                        <tr>
                          <td>
                            <div className={styles.flexOTP}>
                              <div className={styles.label}>
                                {t('Purchase')}
                              </div>
                              <div
                                className={styles.boxValue}
                                style={
                                  values.sellBuyType == 'BUY'
                                    ? { color: '#0BDF39' }
                                    : { color: '#FF0017' }
                                }
                              >
                                {values.sellBuyType == 'BUY'
                                  ? t('BUY 2')
                                  : t('SELL 2')}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className={styles.flexOTP}>
                              <div className={styles.label2}>
                                {t('Order price (VND)')}
                              </div>
                              <div className={styles.boxValue}>
                                {formatNumber(values.orderPrice, 2)}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                      {!isDerivatives &&
                        (values.orderType === OrderType.LO ||
                          values.orderType === OrderType.ODDLOT) && (
                          <tr>
                            <td>
                              <div className={styles.flexOTP}>
                                <div className={styles.label}>
                                  {t('Symbol Code')}
                                </div>
                                <div className={styles.boxValue}>
                                  {values.stockCode}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className={styles.flexOTP}>
                                <div className={styles.label2}>
                                  {t('Value (VND)')}
                                </div>
                                <div className={styles.boxValue}>
                                  {formatNumber(values.tradingValue, 2)}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      {values.expiryDate && (
                        <tr>
                          <td>
                            <div className={styles.flexOTP}>
                              <div className={styles.label}>
                                {t('Expiry Date')}
                              </div>
                              <div className={styles.boxValue}>
                                {formatDateToDisplay(values.expiryDate)}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </OtpModal>
      
    );
  }
}

const ConfirmOrderModal = withErrorBoundary(
  withNamespaces('common')(connect()(ConfirmOrderModalComponent)),
  Fallback,
  handleError
);

export default ConfirmOrderModal;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Modal/ConfirmOrderModal.tsx